import { z } from 'zod';

// NOTE: see ./products.ts; may want to deduplicate this
export const dateTimeSchema = z
  .number()
  .int()
  .gte(1000000000000)
  .lte(3000000000000);

const PAYMENT_OPTIONS = [
  'motorsportlocker-balance',
  'card',
  'bank',
  'paypal',
  'venmo',
] as const;

export const paymentOptionsEnum = z.enum(PAYMENT_OPTIONS);

export const sellerObjectSchema = z.object({
  name: z.string(),
  photo: z
    .string()
    .default(
      'https://ui-avatars.com/api/?background=random&length=2&name=U&size=256'
    )
    .optional(),
});

// A collection of items bought together. Initially designed to track resale items for the Motorsport Locker SoCal account.
// TODO: a 'completed' field could be useful for filtering these out in the create-listing and purchase-entry/index page
export const purchaseEntryDocumentSchema = z.object({
  title: z.string().optional(),
  description: z.string().optional(),
  id: z.string(), // Primary key. TODO: add enforcement for ID format (MXSC######)
  owner_uid: z.string(), // UID of the user that created and owns this purchase entry
  total_purchase_price: z.number(),
  date_of_purchase: dateTimeSchema.default(Date.now()), // Day that entire purchase of items was made
  item_count: z
    .number()
    .min(1, 'Must have at least one item in purchase entry'), // Total number of items bought in deal
  payment_method: paymentOptionsEnum, // Payment method that was used to buy these items
  seller_bought_from: sellerObjectSchema, // The information of the seller items were bought from in this deal (on the website or not)
});

export type SellerData = z.infer<typeof sellerObjectSchema>;
export type PurchaseEntryDocument = z.infer<typeof purchaseEntryDocumentSchema>;
